import type { Options } from './captchaHostStore';
import { useCaptchaHostStoreContext } from './context';

/**
 * The captcha renders through the globally mounted <PerimeterXCaptchaHost/>
 * (see docs/architecture/decisions/2026-06-18-perimeterx-captcha-global-host.md),
 * so this trigger can be fired from render-less async handlers.
 */

export function usePerimeterXCaptcha(): (options: Options) => Promise<boolean> {
	const captchaHostStore = useCaptchaHostStoreContext();
	return async (options) => captchaHostStore.open(options);
}
